import { AuthenticatedLayout } from "../../../layouts";
import { FC } from "react";
import { T4SlipList } from "../../../components/T4Slip";

export interface IT4SlipListPage {}

export const T4SlipListPage: FC<IT4SlipListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="T4 Slip List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Compliance", navigateTo: "/compliance/t4/list" },
        // { text: "T4", navigateTo: "/compliance/t4/list" },
        // { text: "T4 Slips", navigateTo: "/compliance/t4/list" },
      ]}
      mainContents={<T4SlipList />}
    />
  );
};
